namespace TabAurous.Inventory {
    export interface SetMasterForm {
        SKU: Serenity.StringEditor;
        ItemDetails: SetItemsEditor;
    }

    export class SetMasterForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SetMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SetMasterForm.init)  {
                SetMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = SetItemsEditor;

                Q.initFormType(SetMasterForm, [
                    'SKU', w0,
                    'ItemDetails', w1
                ]);
            }
        }
    }
}
